import React from 'react';
import { TertiaryButton } from 'apps/sigma2-ui/src/components/TertiaryButton';
import { IconShareSvg } from 'apps/sigma2-ui/src/components/svg/IconShare';
import { TouchTargetProps } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { CircularProgress } from '@mui/material';

export const DashboardHeaderShareButton: React.FC<
  Pick<TouchTargetProps, 'behavior'> & {
    disabled?: boolean;
    exporting?: boolean;
  }
> = ({ behavior, disabled = false, exporting = false }) => {
  const language = useLanguage();

  return (
    <TertiaryButton
      label={language.share()}
      icon={
        exporting ? (
          <CircularProgress size={16} thickness={4} color="inherit" />
        ) : (
          <IconShareSvg svg={{ className: 'w-6 h-6' }} />
        )
      }
      typographyClassName="hidden min-[1700px]:inline"
      behavior={behavior}
      disabled={disabled}
    />
  );
};
